/**
 * TanStack Query hooks for `bonus-structure-display-for-partners`.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	listForPartner,
	bonusStructureDisplayForPartnersQueryKeys,
	type CreateBonusTierBody,
	type CreateBonusTierResponse,
	type ListBonusStructureResponse,
	type PartnerBonusResponse,
} from "./api";

export function useBonusStructureList(): UseQueryResult<ListBonusStructureResponse, Error> {
	return useQuery({
		queryKey: bonusStructureDisplayForPartnersQueryKeys.list(),
		queryFn: list,
	});
}

export function useBonusStructureForPartner(params: {
	affiliate_id: string;
	campaign_id?: string;
	enabled?: boolean;
}): UseQueryResult<PartnerBonusResponse, Error> {
	return useQuery({
		queryKey: bonusStructureDisplayForPartnersQueryKeys.partner(
			params.affiliate_id,
			params.campaign_id,
		),
		queryFn: () =>
			listForPartner({
				affiliate_id: params.affiliate_id,
				campaign_id: params.campaign_id,
			}),
		enabled: params.enabled !== false && params.affiliate_id.length > 0,
	});
}

export function useBonusStructureCreate(): UseMutationResult<
	CreateBonusTierResponse,
	Error,
	CreateBonusTierBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: bonusStructureDisplayForPartnersQueryKeys.all });
		},
	});
}
